import React from "react";
import './App.css';

const Contact = () =>{
     return(
        <div>
            <h1>Contact US</h1>
            <span className="large-text">To contact us please see our <a href="https://liretro.com/contact/">Contact Information Page</a></span>
        </div>
     );
};
export default Contact;